( function () {
    'use strict';
    ( function ( $ ) {
        var $mq = $('.marquee').marquee({
            pauseOnHover: true,
            startVisible: true
        });
    } )( jQuery );
} )();